$(function() {
/*
  console.log('test');
  console.log(defaultConfig);
  console.log(window.defaultConfig);

  var fp = flatpickr(".js-flatpickr", {
    plugins: [new confirmDatePlugin({
      confirmText: "Pippo ",
      theme: "dark"
    })]
  });
*/
});